<template>
  <form class="human-data">
    <edit-mode v-if="editMode" @close="editMode = false" ></edit-mode>
    <view-mode v-else @modify="editMode = true" ></view-mode>
  </form>
</template>

<script>
  import ViewMode from './PersonalDataViewMode'
  import EditMode from './PersonalDataEditMode'

  export default {
    components: {
      ViewMode, EditMode
    },
    data() {
      return {
        editMode: false
      }
    }
  }
</script>

<style scoped>

</style>
